import React, { Fragment } from "react";
import { withTranslation } from 'react-i18next';
import { withSnackbar } from 'notistack';
import { Link } from 'react-router-dom';
import {
    Grid,
    Chip,
    Card,
    CardHeader,
    CardContent,
    CircularProgress,
    Button,
    TableCell,
    TableRow,
    Fab,
    TableContainer,
    Paper,
    Table,
    TableHead,
    TableBody,
    FormControl,
    Collapse,
    Box,
    TablePagination,
    Tooltip,
    Zoom,
    Typography
} from "@material-ui/core";
import moment from 'moment'
import EditIcon from '@material-ui/icons/Edit';
/* import ZoomInIcon from '@material-ui/icons/ZoomIn'; */
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import { getSpecificClients } from "views/clients/api/apiClients";
import SelectClient from "common/components/custom/SelectClient";
import SelectInventory from "common/components/custom/SelectInventory";
import { changeActiveStatus, getAssets, getEmployeeHistory, getLocationHistory, exportAssetExcelReport, handleContentDisposition, getTotalAmounts } from "../../api/apiAsset";
import { getInventorySimple } from "../../../inventory/api/apiInventory"
import DepreciationRateDetailsDialog from "../rate/DepreciationRateDetailsDialog";
import WrappedAutocomplete from "common/components/custom/WrappedAutocomplete";
import AssetEmployeeHistoryDialog from "./AssetEmployeeHistoryDialog";
import AssetLocationHistoryDialog from "./AssetLocationHistoryDialog";
import NumberFormat from "react-number-format";
import SearchIcon from '@material-ui/icons/Search';
import GetAppIcon from '@material-ui/icons/GetApp'
/* import { getDepreciationGroupsSimple } from "views/accountingConfiguration/api/apiDepreciationGroup"; */
import SortingAndFiltering from "common/components/custom/SortingAndFiltering"
import CustomSelector from "common/components/custom/CustomSelector";
import WrappedTextField from "common/components/custom/WrappedTextField";
import ConfirmationDialog from "common/components/ConfirmationDialog";
/* import { getAccountsSimple } from "views/accountingConfiguration/api/apiAccountingConfiguration";
import WrappedKeyboardDatePicker from "common/components/custom/WrappedKeyboardDatePicker"; */
import { getLocationsSimple } from "views/location/api/apiLocation";
import { getEmployeesSimple } from "views/employee/api/apiEmployee";

class Assets extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            specificsClients: [],
            inventories: [],
            assets: [],
            isLoading: true,
            activePage: 0,
            totalElements: 0,
            rowsPerPage: 25,
            selectedInventory: props.location.state && props.location.state.selectedInventory ? props.location.state.selectedInventory : null,
            client: props.location.state && props.location.state.selectedClient ? props.location.state.selectedClient : null,
            selectedClient: null,
            locationState: null,
            collapseIndex: -1,
            dialogRate: false,
            assetId: null,
            depreciationRates: [],
            historyEmployeeDialog: false,
            historyLocationDialog: false,
            employeesHistory: [],
            locationsHistory: [],
            assetSearch: "",
            assetProjectSearch: "",
            depreciationGroups: [],
            selectedDepreciationGroup: props.location.state && props.location.state.selectedDepreciationGroup ? props.location.state.selectedDepreciationGroup : null,
            filter: '',
            selectedFrom: props.location.state && props.location.state.selectedFrom ? moment(props.location.state.selectedFrom, 'DD-MM-YYYY') : null,
            selectedTo: props.location.state && props.location.state.selectedTo ? moment(props.location.state.selectedTo, 'DD-MM-YYYY') : null,
            selectedRadioButton: props.location.state && props.location.state.selectedRadioButton ? props.location.state.selectedRadioButton : "currentMonth",
            numberOfMonths: 0,
            dialogOpen: false,
            assetIsActive: null,
            selectedAccount: props.location.state && props.location.state.selectedAccount ? props.location.state.selectedAccount : null,
            accounts: [],
            selectedPurchaseDateFrom: null,
            selectedPurchaseDateTo: null,
            totalAmounts: null,
            selectedEmployee: null,
            locations: [],
            employees: [],
            selectedLocation: null,
            assetType: null
        };
    }

    async componentDidMount() {
        this.getSpecificClients()
    }

    handleChangePage = (event, newPage) => {
        this.setState({ activePage: newPage }, () => this.getAssets(newPage, this.state.selectedInventory.id))
    };

    handleChangeRowsPerPage = (event) => {
        this.setState({ rowsPerPage: parseInt(event.target.value, 10), activePage: 0 }, () => this.getAssets(this.state.activePage, this.state.selectedInventory.id))
    };

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.location.state !== this.state.locationState) {
            this.setState({ locationState: prevProps.location.state }, () => this.state.locationState !== undefined ? this.getAssets(0, this.state.selectedInventory.id) : null)
        }
    }

    getSpecificClients = () => {
        getSpecificClients().then((response) => {
            let selectedClient = this.state.client !== null ? this.state.client : response.data.data.length === 0 ? null : response.data.data[0]
            this.setState({ specificsClients: response.data.data, selectedClient: selectedClient }, selectedClient ? this.getInventorySimple(selectedClient.id) : null);
        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t("something_went_wrong"), { variant: 'error' });
        });
    }

    monthDiff = (dateFrom, dateTo) => {
        if (dateFrom === null && dateTo === null) {
            this.setState({
                numberOfMonths: 0,
                assets: []
            })
        } else {
            let monthsDiff = moment(dateTo).diff(moment(dateFrom), 'months', true);
            if (isNaN(monthsDiff)) {
                this.setState({ numberOfMonths: 0 })
            }
            this.setState({ numberOfMonths: Math.floor(monthsDiff) })
        }
    }

    getInventorySimple = (selectedClient) => {
        getInventorySimple(selectedClient).then((response) => {
            let selectedInventory = this.state.selectedInventory !== null ? this.state.selectedInventory : response.data.data.length === 0 ? null : response.data.data[0]
            const firstDayInCurrentYear = moment(new Date()).startOf('month');
            const firstDayInNextMonth = moment(new Date()).endOf('month').add(1, 'days')
            this.monthDiff(firstDayInCurrentYear, firstDayInNextMonth)
            this.setState({
                selectedInventory: selectedInventory,
                inventories: response.data.data,
                selectedTo: this.state.selectedTo !== null ? this.state.selectedTo : firstDayInNextMonth,
                selectedFrom: this.state.selectedFrom !== null ? this.state.selectedFrom : firstDayInCurrentYear,
                isLoading: false
            }, selectedInventory ? () => this.getAssets(0, selectedInventory.id) : null);
            /* this.getDepreciationGroupSimple()
            this.getAccountsSimple() */
            this.getLocationsSimple()
            this.getEmployeesSimple()
        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t("something_went_wrong"), { variant: 'error' });
        });
    }

    /* getDepreciationGroupSimple = () => {
        getDepreciationGroupsSimple(this.state.selectedClient.id).then((response) => {
            this.setState({ depreciationGroups: response.data.data });
        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t("something_went_wrong"), { variant: 'error' });
        });
    }

    getAccountsSimple = () => {
        getAccountsSimple(this.state.selectedClient.id).then((response) => {
            this.setState({ accounts: response.data.data });
        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t("something_went_wrong"), { variant: 'error' });
        });
    } */

    getLocationsSimple = (id) => {
        getLocationsSimple(this.state.selectedClient.id).then((response) => {
            this.setState({ locations: response.data.data });
        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t("something_went_wrong"), { variant: 'error' });
        });
    }

    getEmployeesSimple = (id) => {
        getEmployeesSimple(this.state.selectedClient.id).then((response) => {
            this.setState({ employees: response.data.data });
        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t("something_went_wrong"), { variant: 'error' });
        });
    }


    getAssets = (page, inventoryId) => {
        this.setState({ isLoading: true })
        let requestBody = {
            depreciationFrom: moment(this.state.selectedFrom, 'DD-MM-YYYY').format("DD-MM-YYYY"),
            depreciationTo: moment(this.state.selectedTo, 'DD-MM-YYYY').format("DD-MM-YYYY"),
            purchaseDateFrom: this.state.selectedPurchaseDateFrom !== null ? moment(this.state.selectedPurchaseDateFrom, 'DD-MM-YYYY').format("DD-MM-YYYY") : null,
            purchaseDateTo: this.state.selectedPurchaseDateTo !== null ? moment(this.state.selectedPurchaseDateTo, 'DD-MM-YYYY').format("DD-MM-YYYY") : null
        }
        getAssets({
            params: {
                inventoryId: inventoryId,
                page: page,
                size: this.state.rowsPerPage,
                depreciationGroupId: this.state.selectedDepreciationGroup && this.state.selectedDepreciationGroup.id,
                accountId: this.state.selectedAccount && this.state.selectedAccount.id,
                employee: this.state.selectedEmployee && this.state.selectedEmployee.email,
                location: this.state.selectedLocation && this.state.selectedLocation.id,
                assetType: this.state.assetType !== null ? this.state.assetType : null,
                searchTerm: this.state.assetSearch !== "" ? this.state.assetSearch : null,
                searchProject: this.state.assetProjectSearch !== "" ? this.state.assetProjectSearch : null,
                sort: this.state.filter.sort !== "" ? this.state.filter.sort : null
            }
        }, requestBody).then((response) => {
            this.monthDiff(new Date(this.state.selectedFrom), new Date(this.state.selectedTo))
            this.setState({
                assets: response.data.data.content,
                totalElements: response.data.data.totalElements,
                isLoading: false,
                totalAmounts: null
            }/* , () => this.getTotalAmounts(this.state.selectedInventory.id) */);
        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t("error_get_assets"), { variant: 'error' });
        });
    }

    getTotalAmounts = (inventoryId) => {
        this.setState({ isLoading: true })
        let requestBody = {
            depreciationFrom: moment(this.state.selectedFrom, 'DD-MM-YYYY').format("DD-MM-YYYY"),
            depreciationTo: moment(this.state.selectedTo, 'DD-MM-YYYY').format("DD-MM-YYYY"),
            purchaseDateFrom: this.state.selectedPurchaseDateFrom !== null ? moment(this.state.selectedPurchaseDateFrom, 'DD-MM-YYYY').format("DD-MM-YYYY") : null,
            purchaseDateTo: this.state.selectedPurchaseDateTo !== null ? moment(this.state.selectedPurchaseDateTo, 'DD-MM-YYYY').format("DD-MM-YYYY") : null
        }
        getTotalAmounts({
            params: {
                inventoryId: inventoryId,
                depreciationGroupId: this.state.selectedDepreciationGroup && this.state.selectedDepreciationGroup.id,
                accountId: this.state.selectedAccount && this.state.selectedAccount.id,
                searchTerm: this.state.assetSearch !== "" ? this.state.assetSearch : null,
                searchProject: this.state.assetProjectSearch !== "" ? this.state.assetProjectSearch : null
            }
        }, requestBody).then((response) => {
            this.monthDiff(new Date(this.state.selectedFrom), new Date(this.state.selectedTo))
            this.setState({
                totalAmounts: response.data.data,
                isLoading: false
            });
        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t("error_get_total_amounts_assets"), { variant: 'error' });
        });
    }

    handleChangeClient = (client) => {
        if (client !== null) {
            this.setState({ selectedClient: client, selectedInventory: null }, () => this.getInventorySimple(client.id))
        } else {
            this.setState({ selectedClient: null, selectedInventory: null })
        }
    }

    handleChangeInventory = (inventory) => {
        if (inventory !== null) {
            this.setState({ selectedInventory: inventory, isLoading: true }, () => this.getAssets(0, this.state.selectedInventory.id))
        } else {
            this.setState({ selectedInventory: null, assets: [], totalElements: 0 })
        }
    }

    handleChangeFromDate = (date) => {
        if (date !== null && date._isValid) {
            if (moment(date).isAfter('1900-01-01', 'year') && moment(date).isBefore('2100-01-01', 'year')) {
                this.setState({ selectedFrom: date }, () => this.state.selectedTo !== null ? this.getAssets(this.state.activePage, this.state.selectedInventory.id) : null)
            } else { this.setState({ selectedFrom: date }) }
        }
    }

    handleChangeToDate = (date) => {
        if (date !== null && date._isValid) {
            if (moment(date).isAfter('1900-01-01', 'year') && moment(date).isBefore('2100-01-01', 'year')) {
                this.setState({ selectedTo: date }, () => this.state.selectedFrom !== null ? this.getAssets(this.state.activePage, this.state.selectedInventory.id) : null)
            } else { this.setState({ selectedTo: date }) }
        }
    }

    closeDialog = () => {
        this.setState({ dialogRate: false, assetId: null, depreciationRates: [] });
    }

    closeDialogEmployeeHistory = () => {
        this.setState({ historyEmployeeDialog: false })
    }

    closeDialogLocationHistory = () => {
        this.setState({ historyLocationDialog: false })
    }

    getEmployeeHistory = (asset) => {
        this.setState({ assetId: asset.id })
        getEmployeeHistory(asset.id).then(response => {
            this.setState({ employeesHistory: response.data.data, historyEmployeeDialog: true, assetName: asset.standardAttr.assetName, inventoryNumber: asset.standardAttr.assetInventoryNumber });
        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t("error_get_employee_history"), { variant: 'error' });
        });
    }

    getLocationHistory = (asset) => {
        this.setState({ assetId: asset.id })
        getLocationHistory(asset.id).then(response => {
            this.setState({ locationsHistory: response.data.data, historyLocationDialog: true, assetName: asset.standardAttr.assetName, inventoryNumber: asset.standardAttr.assetInventoryNumber });
        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t("error_get_location_history"), { variant: 'error' });
        });
    }

    changeActiveStatus = () => {
        changeActiveStatus({ params: { isActive: !this.state.assetIsActive } }, this.state.assetId).then(response => {
            this.props.enqueueSnackbar(this.props.t("success_move_to_recycling", { assetName: this.state.assetName }), { variant: 'success' });
            this.setState({ dialogOpen: false, rowsPerPage: this.state.rowsPerPage }, () => this.getAssets(this.state.activePage, this.state.selectedInventory.id));
        }).catch(error => {
            console.log(error)
            this.props.enqueueSnackbar(this.props.t("error_change_active_status"), { variant: 'error' });
        })
    }

    handleAssetSearch = (event) => {
        this.setState({ assetSearch: event.target.value })
    }

    handleAssetProjectSearch = (event) => {
        this.setState({ assetProjectSearch: event.target.value })
    }

    /* handleChangeDeprecationGroup = (depreciationGroup) => {
        if (depreciationGroup !== null) {
            this.setState({ selectedDepreciationGroup: depreciationGroup }, () => { this.getAssets(this.state.activePage, this.state.selectedInventory.id) })
        } else {
            this.setState({ selectedDepreciationGroup: null }, () => { this.getAssets(this.state.activePage, this.state.selectedInventory.id) })
        }
    }

    handleChangeAccount = (account) => {
        if (account !== null) {
            this.setState({ selectedAccount: account }, () => { this.getAssets(this.state.activePage, this.state.selectedInventory.id) })
        } else {
            this.setState({ selectedAccount: null }, () => { this.getAssets(this.state.activePage, this.state.selectedInventory.id) })
        }
    }
 */
    handleChangeEmployee = (employee) => {
        if (employee !== null) {
            this.setState({ selectedEmployee: employee }, () => { this.getAssets(this.state.activePage, this.state.selectedInventory.id) })
        } else {
            this.setState({ selectedEmployee: null }, () => { this.getAssets(this.state.activePage, this.state.selectedInventory.id) })
        }
    }

    handleChangeLocation = (location) => {
        if (location !== null) {
            this.setState({ selectedLocation: location }, () => { this.getAssets(this.state.activePage, this.state.selectedInventory.id) })
        } else {
            this.setState({ selectedLocation: null }, () => { this.getAssets(this.state.activePage, this.state.selectedInventory.id) })
        }
    }

    handleChange = (type) => {
        if (type !== null) {
            this.setState({ assetType: type }, () => { this.getAssets(this.state.activePage, this.state.selectedInventory.id) })
        } else {
            this.setState({ assetType: null }, () => { this.getAssets(this.state.activePage, this.state.selectedInventory.id) })
        }
    };

    changeDates = (selectedFrom, selectedTo, selectedRadioButton) => {
        if (selectedFrom !== null && selectedTo !== null) {
            this.setState({
                selectedFrom: selectedFrom,
                selectedTo: selectedTo,
                selectedRadioButton: selectedRadioButton
            }, () => this.getAssets(this.state.activePage, this.state.selectedInventory.id))
        } else {
            this.setState({
                selectedFrom: selectedFrom,
                selectedTo: selectedTo,
                selectedRadioButton: selectedRadioButton
            })
        }
    }

    exportAssetExcelReport = (inventoryId) => {
        let requestBody = {
            depreciationFrom: moment(this.state.selectedFrom, 'DD-MM-YYYY').format("DD-MM-YYYY"),
            depreciationTo: moment(this.state.selectedTo, 'DD-MM-YYYY').format("DD-MM-YYYY"),
            purchaseDateFrom: this.state.selectedPurchaseDateFrom !== null ? moment(this.state.selectedPurchaseDateFrom, 'DD-MM-YYYY').format("DD-MM-YYYY") : null,
            purchaseDateTo: this.state.selectedPurchaseDateTo !== null ? moment(this.state.selectedPurchaseDateTo, 'DD-MM-YYYY').format("DD-MM-YYYY") : null
        }
        exportAssetExcelReport({
            headers: {
                'Accept': 'application/octet-stream',
                'Access-Control-Expose-Headers': 'Content-Disposition'
            },
            responseType: 'blob',
            params: {
                inventoryId: inventoryId,
                isActive: true,
                depreciationGroupId: this.state.selectedDepreciationGroup && this.state.selectedDepreciationGroup.id,
                accountId: this.state.selectedAccount && this.state.selectedAccount.id,
                searchAsset: this.state.assetSearch !== "" ? this.state.assetSearch : null,
                searchProject: this.state.assetProjectSearch !== "" ? this.state.assetProjectSearch : null,
                employee: this.state.selectedEmployee && this.state.selectedEmployee.email,
                location: this.state.selectedLocation && this.state.selectedLocation.id,
                assetType: this.state.assetType !== null ? this.state.assetType : null,
            }
        }, requestBody).then(response => {
            handleContentDisposition(response)
            this.props.enqueueSnackbar(this.props.t("success_export_to_document"), { variant: 'success' });
        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t("error_export_to_document"), { variant: 'error' });
        });
    }

    handleChangePurchaseDateFrom = (date) => {
        let { selectedPurchaseDateFrom } = this.state;
        selectedPurchaseDateFrom = date !== null ? moment(date).format("DD-MM-YYYY") : null;
        this.setState({ selectedPurchaseDateFrom: selectedPurchaseDateFrom })
    }

    handleChangePurchaseDateTo = (date) => {
        let { selectedPurchaseDateTo } = this.state;
        selectedPurchaseDateTo = date !== null ? moment(date).format("DD-MM-YYYY") : null;
        this.setState({ selectedPurchaseDateTo: selectedPurchaseDateTo }, () => { this.getAssets(this.state.activePage, this.state.selectedInventory.id) })
    }

    render() {

        let { assets, inventories, isLoading, selectedInventory, selectedClient, specificsClients, selectedFrom, selectedTo, collapseIndex, dialogRate, assetId, depreciationRates, assetSearch, /* depreciationGroups ,*/ selectedDepreciationGroup, filter, dialogOpen, /* accounts, selectedAccount, assetProjectSearch, selectedPurchaseDateFrom, selectedPurchaseDateTo, totalAmounts, */ selectedEmployee, selectedLocation, locations, employees, assetType } = this.state;

        if (isLoading) {
            return (
                <div className="loading-position">
                    <CircularProgress className="spinner" color="primary" />
                </div>
            )
        }

        /* let employeesList = []
        let notAssignedObject = { id: null, firstName: 'Not', lastName: 'Assigned', email: "" };
        employees.map(data => { return employeesList.push(data) })
        employeesList.push(notAssignedObject)
        employeesList.sort((a, b) => (a > b) ? 1 : -1) */

        let assetTypeList = ["APARAT ZA KAVU", "GRAĐEVINA/OBJEKT", "HLADNJAK", "KLIMA", "LAPTOP", "LICENCE", "MINER", "MOBITEL", "MONITOR", "MREŽA", "NAMJEŠTAJ", "OPAL", "OSTALO", "PC", "PERILICA", "PISAČ", "PROJEKTOR", "REKLAMA", "ROUTER", "SERVER", "SIM", "SLUŠALICE", "SOFTWARE", "STORAGE", "TIPKOVNICA", "UNIŠTAVAČ PAPIRA", "UPS", "VRSTA"]

        let assetsList;
        let recordsNotFound;
        if (assets && assets.length > 0) {
            assetsList = assets.map((asset, index) => {
                return <Fragment key={index}>
                    <TableRow hover className={index === this.state.collapseIndex ? 'table-custom-header-background' : null}>
                        <TableCell className={index === this.state.collapseIndex ? 'custom-table-cell' : null}>
                            <IconButton aria-label="expand row" size="small" onClick={() => this.setState({ open: !this.state.open, collapseIndex: collapseIndex !== index ? index : -1 })}>
                                {index === collapseIndex ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                            </IconButton>
                        </TableCell>
                        <TableCell className={index === this.state.collapseIndex ? 'custom-table-cell' : null}>{asset.standardAttr.assetInventoryNumber}</TableCell>
                        <TableCell className={index === this.state.collapseIndex ? 'custom-table-cell' : null}>{asset.standardAttr.assetName}</TableCell>
                        <TableCell>{asset.standardAttr.assetType !== "" && asset.standardAttr.assetType !== null ? asset.standardAttr.assetType : "-"}</TableCell>
                        <TableCell>
                            <Tooltip interactive disableFocusListener disableTouchListener arrow transitioncomponent={Zoom} title={asset.employee !== null ? <div style={{ fontSize: '14px' }} >
                                <p><b>{this.props.t("first_name")}: </b> {asset.employee && asset.employee.firstName}</p>
                                <p><b>{this.props.t("last_name")}: </b> {asset.employee && asset.employee.lastName}</p>
                            </div> : <div></div>}>
                                <Chip color="primary" label={<><span style={{ padding: '2px' }}>{asset.employee === null ? this.props.t("not_assigned") : asset.employee.email}</span>{/* <ZoomInIcon /> */}</>} onClick={() => this.getEmployeeHistory(asset)} />
                            </Tooltip>
                        </TableCell>
                        <TableCell>
                            <Tooltip interactive disableFocusListener disableTouchListener arrow transitioncomponent={Zoom} title={asset.location !== null ? <div style={{ fontSize: '14px' }} >
                                <p><b>{this.props.t("floor")}:</b> {asset.location && asset.location.floor}</p>
                                <p><b>{this.props.t("room")}:</b> {asset.location && asset.location.room}</p>
                                <p><b>{this.props.t("city")}:</b> {asset.location && asset.location.city}</p>
                                <p><b>{this.props.t("postal_code")}:</b> {asset.location && asset.location.postalCode}</p>
                            </div> : <div></div>}>
                                <Chip color="primary" label={<><span style={{ padding: '2px' }}>{asset.location === null ? this.props.t("not_assigned") : asset.location.address}</span>{/* <ZoomInIcon /> */}</>} onClick={() => this.getLocationHistory(asset)} />
                            </Tooltip>
                        </TableCell>
                        <TableCell>
                            <Fab title={this.props.t("edit")} onClick={() => this.props.history.push({
                                pathname: '/asset/' + asset.id,
                                state: {
                                    selectedInventory: selectedInventory,
                                    selectedClient: selectedClient,
                                    selectedFrom: moment(selectedFrom).format("DD-MM-YYYY"),
                                    selectedTo: moment(selectedTo).format("DD-MM-YYYY"),
                                    selectedRadioButton: this.state.selectedRadioButton
                                },
                            })} size="small" style={{ marginRight: 10 }} color="secondary" aria-label="edit">
                                <EditIcon />
                            </Fab>
                            <Fab title={this.props.t("change_active_status")} onClick={() => this.setState({ dialogOpen: true, assetId: asset.id, assetIsActive: asset.standardAttr.isActive, assetName: asset.standardAttr.assetName })} size="small" color="inherit" aria-label="change-active-status">
                                <DeleteIcon />
                            </Fab>
                        </TableCell>
                    </TableRow>
                    <TableRow className={index === this.state.collapseIndex ? 'table-custom-body-background' : null}>
                        <TableCell style={{ paddingBottom: 0, paddingTop: 0, border: "none" }} colSpan={12}>
                            <Collapse in={index === this.state.collapseIndex} timeout="auto" unmountOnExit>
                                <Box margin={1}>
                                    <Table aria-label="simple table" size="small" >
                                        <TableHead>
                                            <TableRow>
                                                <TableCell className="table-cell-custom" component="th" scope="row" width="15%">{this.props.t("amount_start_of_year")}</TableCell>
                                                <TableCell className="table-cell-custom" component="th" scope="row" width="15%">{this.props.t("monthly_amount")}</TableCell>
                                                <TableCell className="table-cell-custom" component="th" scope="row" width="15%">{this.props.t("rate")}</TableCell>
                                                <TableCell className="table-cell-custom" component="th" scope="row" width="15%">{this.props.t("residual_value")}</TableCell>
                                                <TableCell className="table-cell-custom" component="th" scope="row" width="15%"></TableCell>
                                                <TableCell className="table-cell-custom" component="th" scope="row" width="15%"></TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            <TableRow hover>
                                                <TableCell><NumberFormat displayType="text" decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} value={asset.depreciationAttr.amountStartOfYear} /></TableCell>
                                                <TableCell><NumberFormat displayType="text" decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} value={asset.depreciationAttr.currentMonthlyAmount} /></TableCell>
                                                <TableCell className={index === this.state.collapseIndex ? 'custom-table-cell' : null}>
                                                    <Chip color="primary" label={<><span style={{ padding: '2px' }}>{asset.depreciationAttr.currentRate}</span>{/* <ZoomInIcon /> */}</>} onClick={() => this.setState({ dialogRate: true, assetId: asset.id, depreciationRates: asset.depreciationRates })} />
                                                </TableCell>
                                                <TableCell><NumberFormat displayType="text" decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} value={asset.standardAttr.residualValue} /></TableCell>
                                                <TableCell></TableCell>
                                                <TableCell></TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                    <Table aria-label="simple table" size="small" >
                                        <TableHead>
                                            <TableRow>
                                                <TableCell className="table-cell-custom" component="th" scope="row" width="15%">{this.props.t("depreciation_group")}</TableCell>
                                                <TableCell className="table-cell-custom" component="th" scope="row" width="15%">{this.props.t("commissioning_date")}</TableCell>
                                                <TableCell className="table-cell-custom" component="th" scope="row" width="15%">{this.props.t("end_date")}</TableCell>
                                                <TableCell className="table-cell-custom" component="th" scope="row" width="15%">{this.props.t("total_months")}</TableCell>
                                                <TableCell className="table-cell-custom" component="th" scope="row" width="15%">{this.props.t("note")}</TableCell>
                                                <TableCell className="table-cell-custom" component="th" scope="row" width="15%"></TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            <TableRow hover>
                                                <TableCell className={index === this.state.collapseIndex ? 'custom-table-cell' : null}>
                                                    <Tooltip interactive disableFocusListener disableTouchListener transitioncomponent={Zoom} arrow title={<div style={{ fontSize: '14px' }}>
                                                        <p><b>{this.props.t("account_group")}:</b> {asset.depreciationGroup && asset.depreciationGroup.accountGroup}</p>
                                                        <p><b>{this.props.t("regular_rate")}:</b> {asset.depreciationGroup && asset.depreciationGroup.regularRate}</p>
                                                        <p><b>{this.props.t("accelerated_rate")}:</b> {asset.depreciationGroup && asset.depreciationGroup.acceleratedRate}</p>
                                                    </div>}>
                                                        <span>{asset.depreciationGroup && asset.depreciationGroup.name}</span>
                                                    </Tooltip>
                                                </TableCell>
                                                <TableCell>{asset.depreciationAttr.dateOfCommissioning}</TableCell>
                                                <TableCell>{asset.depreciationAttr.endDate}</TableCell>
                                                <TableCell>{asset.depreciationAttr.totalMonths}</TableCell>
                                                <TableCell>{asset.standardAttr.note}</TableCell>
                                                <TableCell></TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                    <Table aria-label="simple table" size="small" >
                                        <TableHead>
                                            <TableRow>
                                                <TableCell className="table-cell-custom" component="th" scope="row" width="15%">{this.props.t("project")}</TableCell>
                                                <TableCell className="table-cell-custom" component="th" scope="row" width="15%">{this.props.t("cost_centre")}</TableCell>
                                                <TableCell className="table-cell-custom" component="th" scope="row" width="15%">{this.props.t("inpreparation_account")}</TableCell>
                                                <TableCell className="table-cell-custom" component="th" scope="row" width="15%">{this.props.t("invoice_number")}</TableCell>
                                                <TableCell className="table-cell-custom" component="th" scope="row" width="15%">{this.props.t("quantity")}</TableCell>
                                                <TableCell className="table-cell-custom" component="th" scope="row" width="15%">{this.props.t("vendor")}</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            <TableRow hover>
                                                <TableCell>{asset.standardAttr.project !== "" && asset.standardAttr.project !== null ? asset.standardAttr.project : "-"}</TableCell>
                                                <TableCell>{asset.standardAttr.costCentre !== "" && asset.standardAttr.costCentre !== null ? asset.standardAttr.costCentre : "-"}</TableCell>
                                                <TableCell>{asset.inpreparationAccount && asset.inpreparationAccount.account !== null ? asset.inpreparationAccount.account : "-"}</TableCell>
                                                <TableCell>{asset.standardAttr.invoiceNumber !== "" && asset.standardAttr.invoiceNumber !== null ? asset.standardAttr.invoiceNumber : "-"}</TableCell>
                                                <TableCell>{asset.standardAttr.quantity}</TableCell>
                                                <TableCell>
                                                    <Tooltip interactive disableFocusListener disableTouchListener arrow transitioncomponent={Zoom} title={<div style={{ fontSize: '14px' }} >
                                                        <p><b>{this.props.t("address")}:</b> {asset.vendor && asset.vendor.address}</p>
                                                        <p><b>{this.props.t("city")}:</b> {asset.vendor && asset.vendor.city}</p>
                                                        <p><b>{this.props.t("postal_code")}:</b> {asset.vendor && asset.vendor.postalCode}</p>
                                                    </div>}>
                                                        <span>{asset.vendor && asset.vendor.name}</span>
                                                    </Tooltip>
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                    <Table aria-label="simple table" size="small">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell className="table-cell-custom" component="th" scope="row" width="10%">{this.props.t("date_of_purchase")}</TableCell>
                                                <TableCell className="table-cell-custom" component="th" scope="row" align="right" width="15%">{this.props.t("purchase_amount")}</TableCell>
                                                <TableCell className="table-cell-custom" component="th" scope="row" align="right" width="13%">{this.props.t("previous_depreciation")}</TableCell>
                                                <TableCell className="table-cell-custom" component="th" scope="row" align="right" width="14%">{this.props.t("amount_time_period")}</TableCell>
                                                <TableCell className="table-cell-custom" component="th" scope="row" align="right" width="13%">{this.props.t("amount_after_period")}</TableCell>
                                                <TableCell className="table-cell-custom" component="th" scope="row" width="15%">{this.props.t("account")}</TableCell>
                                                <TableCell className="table-cell-custom" component="th" scope="row" width="15%">{this.props.t("contra_account")}</TableCell>
                                                <TableCell className="table-cell-custom" component="th" scope="row" width="15%">{this.props.t("cost_of_depreciation")}</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            <TableRow hover>
                                                <TableCell>{asset.standardAttr.dateOfPurchase}</TableCell>
                                                <TableCell className={index === this.state.collapseIndex ? 'custom-table-cell-1' : "custom-table-cell-numbers"}><NumberFormat displayType="text" decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} value={asset.standardAttr.purchaseAmount} /></TableCell>
                                                <TableCell className={index === this.state.collapseIndex ? 'custom-table-cell-1' : "custom-table-cell-numbers"}><NumberFormat displayType="text" decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} value={asset.depreciationAttr.amountRequestFrom} /></TableCell>
                                                <TableCell className={index === this.state.collapseIndex ? 'custom-table-cell-1' : "custom-table-cell-numbers"}><NumberFormat displayType="text" decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} value={asset.depreciationAttr.amountTimePeriod} /></TableCell>
                                                <TableCell className={index === this.state.collapseIndex ? 'custom-table-cell-1' : "custom-table-cell-numbers"}><NumberFormat displayType="text" decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} value={asset.depreciationAttr.amountAfterPeriod} /></TableCell>
                                                <TableCell className={index === this.state.collapseIndex ? 'custom-table-cell' : null}>{asset.assetAccount && asset.assetAccount.account}</TableCell>
                                                <TableCell className={index === this.state.collapseIndex ? 'custom-table-cell' : null} >{asset.contraAssetAccount && asset.contraAssetAccount.account}</TableCell>
                                                <TableCell className={index === this.state.collapseIndex ? 'custom-table-cell' : null} >{asset.costAccount && asset.costAccount.account}</TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </Box>
                            </Collapse>
                        </TableCell>
                    </TableRow>
                </Fragment>
            });
        } else {
            recordsNotFound = <TableRow>
                <TableCell align="center" colSpan={12}>
                    <p>{this.props.t("no_records_found")}</p>
                </TableCell>
            </TableRow>
        }

        return <Grid container direction="row" spacing={2}>
            <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                <CardHeader
                    title={this.props.t("assets") + " (" + this.state.totalElements + ")"}
                    action={
                        selectedInventory !== null && <Button component={Link}
                            to={{
                                pathname: `/asset`,
                                state: {
                                    selectedInventory: selectedInventory,
                                    selectedClient: selectedClient,
                                    selectedFrom: moment(selectedFrom).format("DD-MM-YYYY"),
                                    selectedTo: moment(selectedTo).format("DD-MM-YYYY"),
                                    selectedRadioButton: this.state.selectedRadioButton
                                }
                            }}
                            variant="contained" color="secondary" aria-label="edit" style={{ top: '4px' }}>
                            {this.props.t("add_new_asset")}
                        </Button>
                    } />
                <Card>
                    <CardContent>
                        <Grid container direction="row" spacing={2}>
                            <Grid item container direction="column" xs={12} sm={12} md={12} lg={8} xl={9}>
                                <Grid container direction="row" spacing={2}>
                                    <Grid item container direction="column" xs={6} sm={5} md={5} lg={6} xl={5}>
                                        <SelectClient
                                            specificsClients={specificsClients}
                                            selectedClient={selectedClient}
                                            handleChange={this.handleChangeClient}
                                        />
                                    </Grid>
                                    {selectedClient !== null && <Grid item container direction="column" xs={6} sm={5} md={5} lg={6} xl={5}>
                                        <Grid item container>
                                            <SelectInventory
                                                inventories={inventories}
                                                selectedInventory={selectedInventory}
                                                handleChange={this.handleChangeInventory}
                                            />
                                        </Grid>
                                    </Grid>}
                                </Grid>
                                {selectedInventory !== null && <>
                                    <Grid container direction="row" spacing={2}>
                                        <Grid item container direction="column" xs={6} sm={5} md={5} lg={4} xl={5}>
                                            <br />
                                            <Typography variant={"subtitle1"} style={{ fontWeight: 'bold', fontStyle: 'italic' }}>{this.props.t("additional_filer")}</Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid container direction="row" spacing={2}>
                                        {/* <Grid item container direction="column" xs={6} sm={6} md={6} lg={5} xl={5}>
                                            <Grid item container>
                                                <Grid item container>
                                                    <FormControl variant="outlined" fullWidth>
                                                        <WrappedAutocomplete
                                                            label={"search_depreciation_group"}
                                                            placeholder={"search_depreciation_group"}
                                                            name="selectedDepreciationGroup"
                                                            value={selectedDepreciationGroup || null}
                                                            options={depreciationGroups}
                                                            onChange={this.handleChangeDeprecationGroup}
                                                            getOptionLabel={option => option.name ? option.name : ""}
                                                            getOptionSelected={(option, value) => option.id === value.id}
                                                            renderOption={option => (
                                                                <React.Fragment>
                                                                    {option.name ? option.name : ""}
                                                                </React.Fragment>
                                                            )}
                                                        />
                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                        </Grid> */}
                                        <Grid item container direction="column" xs={4} sm={4} md={4} lg={5} xl={5}>
                                            <Grid item container>
                                                <WrappedTextField
                                                    label={"search_asset_name_inv_number"}
                                                    name="searchAsset"
                                                    onChange={this.handleAssetSearch}
                                                    value={assetSearch}
                                                    onKeyPress={(event) => {
                                                        if (event.key === "Enter") {
                                                            this.getAssets(0, selectedInventory.id)
                                                        }
                                                    }}
                                                    InputProps={{ autoComplete: 'off', spellCheck: false }}
                                                />
                                            </Grid>
                                        </Grid>
                                        <Grid item container direction="column" xs={6} sm={6} md={6} lg={5} xl={5}>
                                            <Grid item container>
                                                <FormControl variant="outlined" fullWidth>
                                                    <WrappedAutocomplete
                                                        label={"asset_type"}
                                                        placeholder={"asset_type"}
                                                        name="assetType"
                                                        value={assetType || null}
                                                        options={assetTypeList}
                                                        onChange={this.handleChange}
                                                    />
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                        <Grid item container direction="column" xs={4} sm={4} md={4} lg={5} xl={5}>
                                            <Grid item container>
                                                <FormControl variant="outlined" fullWidth>
                                                    <WrappedAutocomplete
                                                        label={"employee"}
                                                        placeholder={"employee"}
                                                        name="selectedEmployee"
                                                        value={selectedEmployee || null}
                                                        options={employees}
                                                        onChange={this.handleChangeEmployee}
                                                        getOptionLabel={option => option.firstName && option.email ? option.firstName + " " + option.lastName + ", " + option.email : option.email ? option.firstName + " " + option.lastName + ", " + option.email : option.firstName + " " + option.lastName}
                                                        getOptionSelected={(option, value) => option.id === value.id}
                                                        renderOption={option => (
                                                            <React.Fragment>
                                                                {option.firstName && option.email ? option.firstName + " " + option.lastName + ", " + option.email : option.email ? option.firstName + " " + option.lastName + ", " + option.email : option.firstName + " " + option.lastName}
                                                            </React.Fragment>
                                                        )}
                                                    />
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                        <Grid item container direction="column" xs={4} sm={4} md={4} lg={5} xl={5}>
                                            <Grid item container>
                                                <FormControl variant="outlined" fullWidth>
                                                    <WrappedAutocomplete
                                                        label={"location"}
                                                        placeholder={"location"}
                                                        name="selectedLocation"
                                                        value={selectedLocation || null}
                                                        options={locations}
                                                        onChange={this.handleChangeLocation}
                                                        getOptionLabel={option => option.address ? option.address + ", " + this.props.t("floor") + " : " + option.floor + ", " + this.props.t("room") + " : " + option.room : ""}
                                                        getOptionSelected={(option, value) => option.id === value.id}
                                                        renderOption={option => (
                                                            <React.Fragment>
                                                                {option.address ? option.address + ", " + this.props.t("floor") + " : " + option.floor + ", " + this.props.t("room") + " : " + option.room : ""}
                                                            </React.Fragment>
                                                        )}
                                                    />
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                        <Grid item container direction="column" xs={2} sm={2} md={2} lg={3} xl={3}>
                                            <Grid item container>
                                                <Button color="secondary" variant="contained" className="button-with-border-radius" onClick={() => this.getAssets(0, selectedInventory.id)}><SearchIcon /> {this.props.t("search")}</Button>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </>}
                            </Grid>
                            <CustomSelector
                                selectedInventory={selectedInventory}
                                selectedTo={selectedTo}
                                selectedFrom={selectedFrom}
                                handleChangeToDate={this.handleChangeToDate}
                                handleChangeFromDate={this.handleChangeFromDate}
                                numberOfMonths={this.state.numberOfMonths}
                                selectedRadioButton={this.state.selectedRadioButton}
                                changeDates={(selectedFrom, selectedTo, selectedRadioButton) => this.changeDates(selectedFrom, selectedTo, selectedRadioButton)}
                                monthDiff={(dateFrom, dateTo) => this.monthDiff(dateFrom, dateTo)}
                            />
                        </Grid>
                        <Grid container direction="row" spacing={2}>
                            {selectedClient && assets && assets.length > 0 && <Grid item container direction="column" xs={12} sm={4} md={3} lg={3} xl={3} >
                                <Typography variant={"subtitle1"} style={{ fontWeight: 'bold', fontStyle: 'italic' }}>{this.props.t("currency")}: {selectedClient && selectedClient.reportingCurrency}</Typography>
                            </Grid>}
                            <Grid item container direction="column" xs={12} sm={4} md={2} lg={4} xl={5}></Grid>
                            {assets && assets.length > 0 && <Grid item container direction="column" xs={12} sm={4} md={7} lg={5} xl={4}>
                                <TablePagination
                                    component="div"
                                    count={this.state.totalElements}
                                    rowsPerPageOptions={[10, 25, 50, 100]}
                                    page={this.state.activePage}
                                    onPageChange={this.handleChangePage}
                                    rowsPerPage={this.state.rowsPerPage}
                                    onRowsPerPageChange={this.handleChangeRowsPerPage}
                                    backIconButtonText={this.props.t("previous_page")}
                                    labelRowsPerPage={this.props.t("rows_per_page")}
                                    nextIconButtonText={this.props.t("next_page")}
                                />
                            </Grid>}
                        </Grid>
                        {selectedInventory !== null && <><Grid container direction="row" spacing={2}>
                            <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid container direction="row" spacing={2}>
                                    <Grid item container>
                                        <TableContainer component={Paper}>
                                            <Table aria-label="collapsible table" size="small" style={{ tableLayout: 'fixed' }}>
                                                <SortingAndFiltering columns={[
                                                    {
                                                        name: '',
                                                        width: '3%',
                                                    },
                                                    {
                                                        name: this.props.t("inventory_number"),
                                                        dbName: 'asset_inventory_number',
                                                        width: '14%',
                                                        sort: true
                                                    },
                                                    {
                                                        name: this.props.t("name"),
                                                        dbName: 'asset_name',
                                                        width: '20%',
                                                        sort: true
                                                    },
                                                    {
                                                        name: this.props.t("asset_type"),
                                                        width: '15%'
                                                    },
                                                    {
                                                        name: this.props.t("employee"),
                                                        width: '19%'
                                                    },
                                                    {
                                                        name: this.props.t("location"),
                                                        width: '19%'
                                                    },
                                                    {
                                                        name: '',
                                                        width: '10%'
                                                    }
                                                ]}
                                                    filter={filter}
                                                    onSortChange={(sort) => this.setState({ filter: { ...this.state.filter, sort: sort }, page: 0 }, () => this.getAssets(0, this.state.selectedInventory.id))}
                                                />
                                                <TableBody>
                                                    {assetsList}
                                                    {recordsNotFound}
                                                    {/* {assets && assets.length > 0 && <TableRow >
                                                        <TableCell className='custom-table-cell-total'></TableCell>
                                                        <TableCell className='custom-table-cell-total'></TableCell>
                                                        <TableCell className='custom-table-cell-total'>{this.props.t("total")}</TableCell>
                                                        <TableCell className='custom-table-cell-total'></TableCell>
                                                        <TableCell className='custom-table-cell-total'><NumberFormat displayType="text" decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} value={totalAmounts && totalAmounts.totalPurchaseAmount} /></TableCell>
                                                        <TableCell className='custom-table-cell-total'><NumberFormat displayType="text" decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} value={totalAmounts && totalAmounts.totalPreviousDepreciation} /></TableCell>
                                                        <TableCell className='custom-table-cell-total'><NumberFormat displayType="text" decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} value={totalAmounts && totalAmounts.totalCurrentDepreciation} /></TableCell>
                                                        <TableCell className='custom-table-cell-total'><NumberFormat displayType="text" decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} value={totalAmounts && totalAmounts.totalRemainingDepreciation} /></TableCell>
                                                        <TableCell className='custom-table-cell-total'></TableCell>
                                                        <TableCell className='custom-table-cell-total'></TableCell>
                                                        <TableCell className='custom-table-cell-total'></TableCell>
                                                        <TableCell className='custom-table-cell-total'></TableCell>
                                                    </TableRow>} */}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                            {/* <Grid container direction="row" spacing={2}>
                                <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <Grid container direction="row" spacing={2}>
                                        <Grid item container>
                                            <TableContainer component={Paper}>
                                                <Table aria-label="collapsible table" size="small" style={{ tableLayout: 'fixed' }}>
                                                    <TableHead>
                                                    </TableHead>
                                                    <TableBody>
                                                        <TableRow>
                                                            <TableCell></TableCell>
                                                            <TableCell></TableCell>
                                                            <TableCell className='custom-table-cell-1'>{this.props.t("total")}</TableCell>

                                                            <TableCell className='custom-table-cell-1'><NumberFormat displayType="text" decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} value={totalAmounts && totalAmounts.totalPurchaseAmount} /></TableCell>
                                                            <TableCell className='custom-table-cell-1'><NumberFormat displayType="text" decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} value={totalAmounts && totalAmounts.totalPreviousDepreciation} /></TableCell>
                                                            <TableCell className='custom-table-cell-1'><NumberFormat displayType="text" decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} value={totalAmounts && totalAmounts.totalCurrentDepreciation} /></TableCell>
                                                            <TableCell className='custom-table-cell-1'><NumberFormat displayType="text" decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} value={totalAmounts && totalAmounts.totalRemainingDepreciation} /></TableCell>

                                                            <TableCell></TableCell>
                                                            <TableCell></TableCell>
                                                        </TableRow>
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid> */}
                            <Grid container direction="row" spacing={2}>
                                {assets && assets.length > 0 && <Grid item container direction="column" xs={12} sm={4} md={3} lg={2} xl={1} >
                                    <Button color="inherit" variant="contained" className="button-with-border-radius-all" onClick={() => this.exportAssetExcelReport(selectedInventory.id)}><GetAppIcon /> {this.props.t("export")}</Button>
                                </Grid>}
                                <Grid item container direction="column" xs={12} sm={4} md={2} lg={5} xl={7}></Grid>
                                {assets && assets.length > 0 && <Grid item container direction="column" xs={12} sm={4} md={7} lg={5} xl={4}>
                                    <TablePagination
                                        component="div"
                                        count={this.state.totalElements}
                                        rowsPerPageOptions={[10, 25, 50, 100]}
                                        page={this.state.activePage}
                                        onPageChange={this.handleChangePage}
                                        rowsPerPage={this.state.rowsPerPage}
                                        onRowsPerPageChange={this.handleChangeRowsPerPage}
                                        backIconButtonText={this.props.t("previous_page")}
                                        labelRowsPerPage={this.props.t("rows_per_page")}
                                        nextIconButtonText={this.props.t("next_page")}
                                    />
                                </Grid>}
                            </Grid>
                        </>}
                    </CardContent>
                </Card>
            </Grid>
            <DepreciationRateDetailsDialog
                isOpen={dialogRate}
                onClose={this.closeDialog}
                assetId={assetId}
                history={this.props.history}
                depreciationRates={depreciationRates}
                selectedFrom={moment(selectedFrom).format("DD-MM-YYYY")}
                selectedTo={moment(selectedTo).format("DD-MM-YYYY")}
                selectedClient={selectedClient}
                selectedInventory={selectedInventory}
                selectedDepreciationGroup={selectedDepreciationGroup}
                selectedRadioButton={this.state.selectedRadioButton}
            />
            <AssetEmployeeHistoryDialog
                isOpen={this.state.historyEmployeeDialog}
                onClose={this.closeDialogEmployeeHistory}
                employeesHistory={this.state.employeesHistory}
                assetName={this.state.assetName}
                history={this.props.history}
                assetId={assetId}
                selectedClient={selectedClient}
                selectedInventory={selectedInventory}
                inventoryNumber={this.state.inventoryNumber}
                selectedFrom={moment(selectedFrom).format("DD-MM-YYYY")}
                selectedTo={moment(selectedTo).format("DD-MM-YYYY")}
                selectedRadioButton={this.state.selectedRadioButton}
            />
            <AssetLocationHistoryDialog
                isOpen={this.state.historyLocationDialog}
                onClose={this.closeDialogLocationHistory}
                locationsHistory={this.state.locationsHistory}
                assetName={this.state.assetName}
                history={this.props.history}
                assetId={assetId}
                selectedClient={selectedClient}
                selectedInventory={selectedInventory}
                inventoryNumber={this.state.inventoryNumber}
                selectedFrom={moment(selectedFrom).format("DD-MM-YYYY")}
                selectedTo={moment(selectedTo).format("DD-MM-YYYY")}
                selectedRadioButton={this.state.selectedRadioButton}
            />
            <ConfirmationDialog
                isOpen={dialogOpen}
                title={this.props.t("change_active_status")}
                message={this.props.t("message_move_asset_recycling", { assetName: this.state.assetName })}
                onClose={() => this.setState({ dialogOpen: false })}
                onConfirm={() => this.setState({ dialogOpen: false }, () => this.changeActiveStatus())}
                closeButtonTitle={this.props.t("close")}
                confirmButtonTitle={this.props.t("move")}
            />
        </Grid>
    }
}

export default withSnackbar(withTranslation()(Assets))